import * as STEP_STATES from './activation-brief-step-states';
export const NAME_COMPENSATION = 'compensation';
export const NAME_PRODUCTS = 'products';
export const NAME_TASKS = 'tasks';
export const NAME_UPLOAD_FILES = 'upload_files';
export const NAME_NETWORKS = 'networks';
export const NAME_SHIPPING_INFO = 'shipping_info';
export const NAME_PERSONAL_INFO = 'personal_info';
export const NAME_BRAND_ASSETS = 'brand_assets';
export const NAME_CONTENT_AGREEMENT = 'content_agreement';
export const SIDE_ICON_NAMES = {
    [NAME_COMPENSATION]: 'dollar-sign',
    [NAME_PRODUCTS]: 'shopping-cart',
    [NAME_TASKS]: 'list',
    [NAME_UPLOAD_FILES]: 'upload',
    [NAME_NETWORKS]: 'hashtag',
    [NAME_SHIPPING_INFO]: 'home',
    [NAME_PERSONAL_INFO]: 'user',
    [NAME_BRAND_ASSETS]: 'file-alt',
    [NAME_CONTENT_AGREEMENT]: 'file-signature'
};
export const SIDE_ICON_TYPES = {
    [STEP_STATES.PENDING]: 'light',
    [STEP_STATES.CURRENT]: 'light',
    [STEP_STATES.COMPLETED]: 'solid',
    [STEP_STATES.ERROR]: 'solid'
};
